module.exports = __webpack_public_path__ + "img/child.bad95970.svg";